import { Component, computed, signal, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { LorenLineChartNote } from "../../interfaces/loren-line-chart-note.interface";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { TranslocoPipe } from "@jsverse/transloco";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { LorenDateModule } from "../../../../pipes/loren-date/loren-date.module";
import { MatInputModule } from "@angular/material/input";
import { MatButton } from "@angular/material/button";

@Component({
  imports: [
    FormsModule,
    TranslocoPipe,
    MatSelect,
    MatInputModule,
    MatOption,
    MatFormFieldModule,
    MatDialogModule,
    LorenDateModule,
    MatButton,
  ],
  selector: "loren-chart-note-dialog",
  standalone: true,
  styleUrls: ["./loren-chart-note-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "loren-chart-note-dialog.component.html",
})
export class LorenChartNoteDialog {
  dialogRef = inject<MatDialogRef<LorenChartNoteDialog>>(MatDialogRef);
  data = inject<{
    notes: LorenLineChartNote[][];
    meterings: {
        name: string;
        id: number;
        color: string;
    }[];
    clickedSeries;
}>(MAT_DIALOG_DATA);


  newNote: string;

  selectedMetric = signal<{ name: string; id: number }>(
    this.data.clickedSeries
      ? this.data.meterings.find((m) => m.id === this.data.clickedSeries.id)
      : this.data.meterings[0]
  );
  notesShown = computed(() =>
    this.data.notes.find((n) => n[0].meteringId === this.selectedMetric().id)
  );

  onCancel(): void {
    this.dialogRef.close();
  }

  handleSelectionChange(event) {
    this.selectedMetric.set(
      this.data.meterings.find((m) => m.id === event.value)
    );
  }
}
